/* RICIAL Luma panel pages: gallery, quantity stepper, lens follow. */
(function () {
  function init(root) {
    var main = root.querySelector('.rl-gal__main img');
    root.querySelectorAll('.rl-gal__thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        if (!main) return;
        main.style.opacity = '0.2';
        var img = new Image();
        img.onload = function () { main.removeAttribute('srcset'); main.src = t.dataset.rlSrc; main.alt = t.dataset.rlAlt || main.alt; main.style.opacity = '1'; };
        img.src = t.dataset.rlSrc;
        root.querySelectorAll('.rl-gal__thumb').forEach(function (x) { x.classList.toggle('is-on', x === t); });
      });
    });
    root.querySelectorAll('[data-rl-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = b.parentNode.querySelector('input');
        i.value = Math.max(1, (parseInt(i.value, 10) || 1) + parseInt(b.dataset.rlQty, 10));
      });
    });
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('[data-rl-lens]').forEach(function (l) {
      if (reduce) return;
      var bx = parseFloat(l.dataset.x), by = parseFloat(l.dataset.y);
      l.addEventListener('pointermove', function (ev) {
        var r = l.getBoundingClientRect();
        var dx = (ev.clientX - r.left) / r.width - 0.5, dy = (ev.clientY - r.top) / r.height - 0.5;
        l.style.backgroundPosition = (bx + dx * 16) + '% ' + (by + dy * 16) + '%';
      });
      l.addEventListener('pointerleave', function () { l.style.backgroundPosition = bx + '% ' + by + '%'; });
    });
  }
  function boot() { document.querySelectorAll('.rl').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
